import { useTheme } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import React, { useEffect, useState } from "react";
import {
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import api from "../../services/api";
import CustomTooltip from "./CustomTooltip";
import Title from "./Title";
import { toast } from "react-toastify";

const ChartPerConnection = () => {
  const theme = useTheme();

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const [initialSelectedDate, setInitialSelectedDate] =
    useState(getCurrentDate);
  const [finalSelectedDate, setFinalSelectedDate] = useState(getCurrentDate);

  const [connectionChartData, setConnectionChartData] = useState([]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const fetchTicketsPorSetores = async () => {
        try {
          const { data } = await api.get("/tickets-por-conexao", {
            params: {
              initialSelectedDate,
              finalSelectedDate,
            },
          });

          setConnectionChartData(data.ticketsPorConexao);
        } catch (error) {
          toast.error("Erro ao carregar gráfico de Tickets por Conexão!");
        }
      };

      fetchTicketsPorSetores();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [initialSelectedDate, finalSelectedDate]);

  return (
    <React.Fragment>
      <Title>{"Tickets por Conexão"}</Title>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "16px",
        }}
      >
        <TextField
          label={"Data inicial"}
          type="date"
          value={initialSelectedDate}
          onChange={(e) => setInitialSelectedDate(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          label={"Data final"}
          type="date"
          value={finalSelectedDate}
          onChange={(e) => setFinalSelectedDate(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </div>
      <ResponsiveContainer width="95%" height={265}>
        <PieChart>
          <Pie
            data={connectionChartData}
            dataKey="value"
            nameKey="name"
            cx="40%"
            cy="50%"
            outerRadius={80}
            fill={theme.palette.primary.main}
            label
          >
            {connectionChartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} cursor={true} />
          {connectionChartData.length > 0 && (
            <Legend verticalAlign="middle" align="right" layout="vertical" />
          )}
        </PieChart>
      </ResponsiveContainer>
    </React.Fragment>
  );
};

export default ChartPerConnection;
